(() => {
  const host = document.querySelector('.pk-configurator-embed');
  if (!host) return;
  const frame = host.querySelector('iframe');
  const configuredBase = host.dataset.appUrl;
  const isLocalThemePreview = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
  const base = isLocalThemePreview ? 'http://localhost:3000' : configuredBase;
  if (!frame || !base) return;

  const sourceUrl = new URL(base);
  sourceUrl.searchParams.set('embedded', '1');
  const pageParams = new URLSearchParams(window.location.search);
  const attributionKeys = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'campaign_id', 'adset_id', 'ad_id', 'fbclid', 'fbc', 'fbp', 'tracking_test'
  ];
  if (window.PKPrivacy?.marketingAllowed()) {
    attributionKeys.forEach((key) => {
      const pageValue = pageParams.get(key) || '';
      if (pageValue) {
        try { sessionStorage.setItem(`pk-attribution-${key}`, pageValue); } catch (_) {}
      }
      let value = pageValue;
      if (!value) {
        try { value = sessionStorage.getItem(`pk-attribution-${key}`) || ''; } catch (_) {}
      }
      if (value) sourceUrl.searchParams.set(key, value);
    });
  }

  if (pageParams.get('visualisierung') === 'angefragt') {
    const storedNumber = sessionStorage.getItem('pk-visualization-request-number') || '';
    const requestNumber = /^[A-Z0-9-]{1,40}$/.test(storedNumber) ? storedNumber : '';
    const startUrl = new URL(window.location.href);
    startUrl.searchParams.delete('visualisierung');
    host.classList.add('pk-configurator-success');
    host.innerHTML = `
      <div class="pk-configurator-success-card" role="status" aria-live="polite">
        <span class="pk-configurator-success-mark" aria-hidden="true">✓</span>
        <p class="eyebrow">Visualisierung angefragt</p>
        <h2>Deine Planung ist bei uns angekommen.</h2>
        <p>Wir prüfen deine Zusammenstellung persönlich und melden uns mit den nächsten Schritten.</p>
        ${requestNumber ? `<strong>Anfragenummer ${requestNumber}</strong>` : ''}
        <div class="pk-configurator-success-actions">
          <a class="button" href="${startUrl.toString()}">Weitere Planung starten</a>
          <a class="button button-ghost-success" href="/">Zur Startseite</a>
        </div>
      </div>`;
    return;
  }

  ['modell', 'material', 'kollektion'].forEach((key) => {
    const value = pageParams.get(key);
    if (value) sourceUrl.searchParams.set(key, value);
  });
  host.style.overflowAnchor = 'none';
  frame.style.overflowAnchor = 'none';
  let pendingScrollTop = null;
  let pendingScrollTimer = 0;

  const postConsentState = () => {
    if (!frame.contentWindow) return;
    frame.contentWindow.postMessage({
      type: 'polsterkonzept-consent-state',
      analytics: window.PKPrivacy?.analyticsAllowed() === true,
      marketing: window.PKPrivacy?.marketingAllowed() === true,
    }, sourceUrl.origin);
  };

  const visibleHeaderOffset = () => Array.from(document.querySelectorAll('header')).reduce((offset, candidate) => {
    if (!(candidate instanceof HTMLElement)) return offset;
    const style = window.getComputedStyle(candidate);
    if (style.position !== 'fixed' && style.position !== 'sticky') return offset;
    const rect = candidate.getBoundingClientRect();
    if (rect.top > 1 || rect.bottom <= 0 || rect.width === 0 || rect.height === 0) return offset;
    return Math.max(offset, Math.ceil(rect.bottom));
  }, 0);

  const scheduleConfiguratorScroll = (innerTop) => {
    pendingScrollTop = Math.max(0, Math.round(innerTop));
    window.clearTimeout(pendingScrollTimer);
    pendingScrollTimer = window.setTimeout(() => {
      window.requestAnimationFrame(() => {
        if (pendingScrollTop === null) return;
        const targetTop = pendingScrollTop;
        pendingScrollTop = null;
        const frameTop = frame.getBoundingClientRect().top + window.scrollY;
        const gap = window.innerWidth <= 749 ? 48 : 24;
        window.scrollTo({
          top: Math.max(0, frameTop + targetTop - visibleHeaderOffset() - gap),
          behavior: 'smooth',
        });
      });
    }, 160);
  };

  frame.src = sourceUrl.toString();

  document.addEventListener('visitorConsentCollected', postConsentState);
  document.addEventListener('pk:privacy-ready', postConsentState);

  window.addEventListener('message', (event) => {
    if (event.source !== frame.contentWindow || event.origin !== sourceUrl.origin || !event.data) return;
    if (event.data.type === 'polsterkonzept-consent-request') {
      postConsentState();
      return;
    }
    if (event.data.type === 'polsterkonzept-configurator-height') {
      const height = Number(event.data.height);
      if (Number.isFinite(height) && height >= 700 && height <= 15000) {
        frame.style.height = `${Math.ceil(height)}px`;
        if (pendingScrollTop !== null) scheduleConfiguratorScroll(pendingScrollTop);
      }
    }
    if (event.data.type === 'polsterkonzept-configurator-scroll') {
      const innerTop = Number(event.data.top);
      if (Number.isFinite(innerTop)) scheduleConfiguratorScroll(innerTop);
    }
    if (event.data.type === 'polsterkonzept-visualization-requested') {
      const requestNumber = String(event.data.requestNumber || '');
      if (/^[A-Z0-9-]{1,40}$/.test(requestNumber)) {
        sessionStorage.setItem('pk-visualization-request-number', requestNumber);
      }
      const successUrl = new URL(window.location.href);
      successUrl.searchParams.set('visualisierung', 'angefragt');
      window.location.assign(successUrl.toString());
    }
  });
})();
